<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="getTableData()">
      <el-tab-pane label="制作" name="production">
        <search-table
          ref="searchTable"
          :columnMove="false"
          :columns="productionColumns"
          :data="tableData"
          :need-pagination="false"
          :needAllColumnSummary="true"
          :showSummary="true"
          :tableRowKey="'id'"
          @getTableData="getTableData"
        >
          <template #detailAction="scope">
            <el-link type="primary" @click="openDetail(scope.row)">详情</el-link>
          </template>
        </search-table>
      </el-tab-pane>
      <el-tab-pane label="式样" name="style">
        <search-table
          ref="styleSearchTable"
          :columnMove="false"
          :columns="styleColumns"
          :data="tableData"
          :need-pagination="false"
          :needAllColumnSummary="true"
          :showSummary="true"
          :tableRowKey="'id'"
        >
          <template #detailActionStyle="scope">
            <el-link type="primary" @click="openDetail(scope.row)">详情</el-link>
          </template>
        </search-table>
      </el-tab-pane>
    </el-tabs>
    <processStatisticsDialog
      :condition="activeTab === 'production' ? '制作' : '式样'"
      :endTime="daytime && daytime[1]"
      :module="module"
      :startTime="daytime && daytime[0]"
      :stffName="searchFormStffName"
      :visible.sync="detailDialogVisible"
    />
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTableV3.vue';
import ProcessStatisticsDialog from '@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/TabChild/ProcessStatisticsDialog';

const labelMap = {
  typesetting: {
    qtyLabel: '片数',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  stap: {
    qtyLabel: '印花数量',
    qtyProp: 'new_print_quantity',
    modifyQtyProp: 'modify_print_quantity',
    oldQtyProp: 'old_print_quantity',
    sampleProp: 'sample_quantity'
  },
  emcd: {
    qtyLabel: '制卡个数',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  lase: {
    qtyLabel: '激光用量',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  embr: {
    qtyLabel: '电绣片数',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  handCut: {
    qtyLabel: '手裁用量',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  stpr: {
    qtyLabel: '数量',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  comp: {
    qtyLabel: '复合用量',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  mase: {
    qtyLabel: '缝纫片数',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  manu: {
    qtyLabel: '样品数量',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  insp: {
    qtyLabel: '数量',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  inbound: {
    qtyLabel: '数量',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  quotation: {
    qtyLabel: '数量',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  },
  dataEntry: {
    qtyLabel: '数量',
    qtyProp: 'new_piece_count',
    modifyQtyProp: 'modify_piece_count',
    oldQtyProp: 'old_piece_count',
    sampleProp: 'sample_count'
  }
};

export default {
  components: { SearchTable, ProcessStatisticsDialog },
  props: ['tableData', 'module', 'daytime', 'processType'],
  data() {
    return {
      activeTab: 'production',
      detailDialogVisible: false,
      styleColumns: [
        { label: '试样制作人', prop: 'experiment_stff_name', itemType: 'input', input: false, sortable: false, widthAuto: true },
        { label: '试样个数', prop: 'rfid_sample_indnum', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '试样片数', prop: 'rfid_sample_slicenum', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '详情', prop: 'detailActionStyle', itemType: 'input', input: false, sortable: false, widthAuto: true, invisible: false }
      ],
      currentRow: {}
    };
  },
  computed: {
    productionColumns() {
      const cfg = labelMap[this.processType] || labelMap.stap;
      return [
        { label: '员工姓名', prop: 'employee_name', itemType: 'input', input: true, sortable: false, widthAuto: true },
        { label: '新款款数', prop: 'new_style_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: `新款${cfg.qtyLabel}`, prop: cfg.qtyProp, itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '修改款数', prop: 'modify_style_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: `修改${cfg.qtyLabel}`, prop: cfg.modifyQtyProp, itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '老款款数', prop: 'old_style_count', itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: `老款${cfg.qtyLabel}`, prop: cfg.oldQtyProp, itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '样品数量', prop: cfg.sampleProp, itemType: 'input', input: false, sortable: true, widthAuto: true },
        { label: '详情', prop: 'detailAction', itemType: 'input', input: false, sortable: false, widthAuto: true, invisible: false }
      ];
    },
    searchFormStffName() {
      return this.currentRow.employee_name || this.currentRow.experiment_stff_name || null;
    }
  },
  methods: {
    getTableData() {
      this.$emit('getTableData', this.getSearchForm());
    },
    getSearchForm() {
      const form = this.$refs.searchTable?.searchForm;
      if (form) {
        form.condition = this.activeTab === 'production' ? '制作' : '式样';
      }
      return form;
    },
    resetFields() {
      this.$refs.searchTable?.resetFields();
    },
    openDetail(row) {
      this.currentRow = row;
      this.detailDialogVisible = true;
    }
  }
};
</script>
